<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick" @pagechange="pagechange"></vggrid>
    <el-dialog :title="fc.fcid ? '修改' : '新增'" :visible.sync="fcform">
      <el-form class="small-space" :model="fc" label-position="left" label-width="80px" ref="ruleForm" style='width: 400px; margin-left:50px;'>
        <el-form-item label="财务月份" required>
          <el-input v-model="fc.fcfmon"></el-input>
        </el-form-item>
        <el-form-item label="开始日期" required>
          <el-date-picker v-model="fc.fcbegdate" type="date"></el-date-picker>
        </el-form-item>
        <el-form-item label="开始日期" required>
          <el-date-picker v-model="fc.fcenddate" type="date"></el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="fcform = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="生成财务日历" :visible.sync="fatchForm">
      <el-form ref="tempRow"  label-width="110px" class="fs2em">
        <el-row justify="center" type="flex">
          <el-col :span="13">
            <el-form-item label="所属年份"  prop="fc_year">
              <el-date-picker size="mini"
                              v-model="fcyear"
                              type="year"
                              placeholder="选择年份"
                              format="yyyy"
                              value-format="yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row justify="center" type="flex" style="margin-bottom: 40px">
          <el-col :span="11">
            <p>说明：</p>
            <p>1.财务月份按照自然月份</p>
            <p>2.每个开始日期和结束日期，按照当前月份的自然日期</p>
          </el-col>
        </el-row>

        <el-form-item >
          <el-row justify="center" type="flex">
            <el-col :span="6">
              <el-button type="primary"  @click="batchGen" >生成</el-button>
            </el-col>
            <el-col :span="6">
              <el-button type="info" @click="detailClose" >关闭</el-button>
            </el-col>
          </el-row>
        </el-form-item>

      </el-form>

    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'fcIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'fcfmon', fieldtype: 'C', title: '财务月份',calculExpr:'', addNewRowFlg: false},
          { field: 'fcbegdate', fieldtype: 'D', title: '开始日期',calculExpr:'',addNewRowFlg: false,formatter:['toDateString', 'yyyy-MM-dd']},
          { field: 'fcenddate', fieldtype: 'D', title: '结束日期',calculExpr:'',addNewRowFlg: false,formatter:['toDateString', 'yyyy-MM-dd']},
          { field: 'fcyear', fieldtype: 'C',title: '所属年份',calculExpr:'',addNewRowFlg: false}
        ],
        fcyear: '',
        fatchForm: false,
        fcform: false,
        fc: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addFc())
      this.$on('CHG', () => this.chgFc())
      this.$on('DEL', () => this.delFc())
      this.$on('BATCH', () => this.batchFc())
      this.$on('CLOSE', () => this.close())
      this.getFcList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addFc () {
        this.fc = {}
        this.fcform = true
      },
      async chgFc () {
        this.fcform = true
      },
      async batchFc () {
        this.fatchForm = true
      },
      async detailClose () {
        this.fatchForm = false
      },
      async delFc () {
        console.log(this.fc)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/basic/fc/delFc',
            method: "post",
            data: this.fc
          })
          if (data.issuccess===1) {
            this.getFcList()
            this.$message.success('删除成功！')
          }
        })
      },
      handleSizeChange (val) {
        this.query.pageSize = val
        this.getFcList()
      },
      handleCurrentChange (val) {
        this.offset = val
        this.getFcList()
      },
      search (target) {},
      async save () {
        this.fc.comid = this.$store.getters.loginUser.usercomid
        this.fc.fcbegdate = utils.formatterDate(this.fc.fcbegdate, 'yyyy-MM-dd')
        this.fc.fcenddate =  utils.formatterDate(this.fc.fcenddate, 'yyyy-MM-dd')
        await request({
          url: '/basic/fc/addOrEdit',
          method: "post",
          data: this.fc
        })
        this.$message.success('操作成功')
        this.fcform = false
        if (!this.fc.fcid) {
          this.query.currPage = 1
        }
        await this.getFcList()
      },
      async cellClick (row) {
        this.fc = row.row
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getFcList()
      },
      async getFcList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/basic/fc/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      async batchGen(){
        let model = {comid: this.$store.getters.loginUser.usercomid,fcyear: this.fcyear}

        let data = await request({
          url: '/basic/fc/batchAdd',
          method: 'post',
          data: model
        })
        if (data.issuccess===1) {
          this.getFcList()
          this.fatchForm = false
          this.$message.success('财务月份批生成成功！')
        } else {
          this.$message.success('财务月份批生成失败！')
        }
      }
    },
    filters: {
      newDate (val) {
        return utils.formatterDate(val, 'yyyy-MM-dd')
      }
    }
  }
</script>
<style lang="scss">

</style>
